import { createFileRoute } from '@tanstack/react-router';
import {
  loadSimulationMessages,
  loadSimulationRenewalScreens,
  simulationPublicRefinancingScreen,
} from '@/modules/simulation/route';
import { flowSearchSchema } from '@/shared/flow/define-flow';
import { lazyScreen } from '@/shared/screen/lazy-screen';

export const Route = createFileRoute('/_app/ccb/contratar/consignado-publico/refinanciamento/')({
  validateSearch: flowSearchSchema(),
  staticData: { screen: simulationPublicRefinancingScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationRenewalScreens, 'PublicRefinancingRouteScreen'),
});
